// eslint-disable-next-line no-shadow
export enum Qualities {
	REGULAR = 'regular',
	PLUS = 'plus',
	PRO = 'pro',
	ULTRA = 'ultra',
}
